import dayjs from 'dayjs';
import { FaTasks } from 'react-icons/fa';
import { MdFeedback, MdOutlineRestaurantMenu } from 'react-icons/md';
import { buildParams, concatPath } from '../../../helpers/path';
import {
  DashboardPath,
  DevicesPath,
  FormPath,
  InformerPath,
  LeadesPath,
  ManagerPath,
  MenuPath,
  PromotionPath,
  QrCodesPath,
  ReviewsPath,
  RootPath,
  StaffPath,
  // MonitoringPath,
  TasksPath,
  TreesPath,
  MonitoringScopePath
} from '../../../routes/manager/manager-enums';
import { DashboardIcon } from './icons/dashboard';
import { DevicesIcon } from './icons/devices';
import { FeedbacksIcon } from './icons/feedbacks';
import { FormsIcon } from './icons/forms';
import { LeadsIcon } from './icons/leads';
import { MenusIcon } from './icons/menus';
import { PromosIcon } from './icons/promos';
import { QrsIcon } from './icons/qrs';
import { StaffIcon } from './icons/staff';
import { TasksIcon } from './icons/tasks';
import { TreesIcon } from './icons/trees';
import { MonitoringIcon } from './icons/monitoring';
import { MenuTabType } from './use-navigation';

export const defaultDashboardRange = {
  from: dayjs(new Date().toISOString()).add(-1, 'week').toISOString(),
  to: dayjs(new Date().toISOString()).endOf('day').toISOString(),
};

const dashboardDefaultParams = buildParams({ range: JSON.stringify(defaultDashboardRange) });

export const navigationTabs: MenuTabType[] = [
  {
    icon: <DashboardIcon />,
    id: ManagerPath.Dashboard,
    value: 'Дашборд',
    permissionsService: 'dashboard',
    subMenu: [
      {
        id: DashboardPath.Menu,
        icon: <MdOutlineRestaurantMenu />,
        value: 'Меню',
        href: concatPath([RootPath.Manager, ManagerPath.Dashboard, DashboardPath.Menu]),
        defaultParams: dashboardDefaultParams,
        service: 'menu',
      },
      {
        id: DashboardPath.Tasks,
        icon: <FaTasks />,
        value: 'Задачи',
        href: concatPath([RootPath.Manager, ManagerPath.Dashboard, DashboardPath.Tasks]),
        defaultParams: dashboardDefaultParams,
      },
      {
        id: DashboardPath.Reviews,
        icon: <MdFeedback />,
        value: 'Отзывы',
        href: concatPath([RootPath.Manager, ManagerPath.Dashboard, DashboardPath.Reviews]),
        defaultParams: dashboardDefaultParams,
      },
      {
        id: DashboardPath.Staff,
        value: 'Сотрудники',
        href: concatPath([RootPath.Manager, ManagerPath.Dashboard, DashboardPath.Staff]),
        defaultParams: dashboardDefaultParams,
      },
      {
        id: DashboardPath.Qr,
        value: 'QR-коды',
        href: concatPath([RootPath.Manager, ManagerPath.Dashboard, DashboardPath.Qr]),
        defaultParams: dashboardDefaultParams,
      },
      {
        id: DashboardPath.ExternalMonitoring,
        value: 'Внешний мониторинг',
        href: concatPath([RootPath.Manager, ManagerPath.Dashboard, DashboardPath.ExternalMonitoring]),
        defaultParams: dashboardDefaultParams,
      },
    ],
  },
  {
    icon: <QrsIcon />,
    id: ManagerPath.QrCodes,
    value: 'QR-коды',
    href: concatPath([RootPath.Manager, ManagerPath.QrCodes, QrCodesPath.StaticList]),
    permissionsService: 'qr',
  },
  {
    icon: <FeedbacksIcon />,
    id: ManagerPath.Reviews,
    value: 'Отзывы',
    permissionsService: 'review',
    subMenu: [
      {
        id: ReviewsPath.Branch,
        value: 'Филиалы',
        href: concatPath([RootPath.Manager, ManagerPath.Reviews, ReviewsPath.Branch]),
      },
      {
        id: ReviewsPath.Order,
        value: 'Заказы',
        href: concatPath([RootPath.Manager, ManagerPath.Reviews, ReviewsPath.Order]),
        service: 'menu',
      },
      {
        id: ReviewsPath.Action,
        value: 'Услуги',
        href: concatPath([RootPath.Manager, ManagerPath.Reviews, ReviewsPath.Action]),
        service: 'feedback',
      },
    ],
  },
  {
    icon: <TreesIcon />,
    id: ManagerPath.Trees,
    value: 'Деревья',
    href: concatPath([RootPath.Manager, ManagerPath.Trees, TreesPath.ListTree]),
    permissionsService: 'tree',
  },
  {
    icon: <TasksIcon />,
    id: ManagerPath.Tasks,
    value: 'Задачи',
    permissionsService: 'task',
    subMenu: [
      {
        id: TasksPath.Order,
        value: 'Заказ',
        href: concatPath([RootPath.Manager, ManagerPath.Tasks, TasksPath.Order]),
        service: 'menu',
      },
      {
        id: TasksPath.Action,
        value: 'Услуга',
        href: concatPath([RootPath.Manager, ManagerPath.Tasks, TasksPath.Action]),
        service: 'feedback',
      },
      {
        id: TasksPath.Common,
        value: 'Админ',
        href: concatPath([RootPath.Manager, ManagerPath.Tasks, TasksPath.Common]),
      },
      {
        id: TasksPath.Planner,
        value: 'Планировщик',
        href: concatPath([RootPath.Manager, ManagerPath.Tasks, TasksPath.Planner]),
      },
    ],
  },
  {
    icon: <StaffIcon />,
    id: ManagerPath.Staff,
    value: 'Стафф',
    permissionsService: 'staff',
    subMenu: [
      {
        id: StaffPath.Employees,
        value: 'Сотрудники',
        href: concatPath([RootPath.Manager, ManagerPath.Staff, StaffPath.Employees]),
      },
      {
        id: StaffPath.CheckInCheckOut,
        value: 'Приход/Уход',
        href: concatPath([RootPath.Manager, ManagerPath.Staff, StaffPath.CheckInCheckOut]),
      },
      {
        id: StaffPath.Shifts,
        value: 'Смены',
        href: concatPath([RootPath.Manager, ManagerPath.Staff, StaffPath.Shifts]),
      },
      {
        id: StaffPath.Statements,
        value: 'Заявления',
        href: concatPath([RootPath.Manager, ManagerPath.Staff, StaffPath.Statements]),
      },
      {
        id: StaffPath.RolesDictionary,
        value: 'Справочник ролей',
        href: concatPath([RootPath.Manager, ManagerPath.Staff, StaffPath.RolesDictionary]),
        userRole: 'admin_head',
      },
    ],
  },
  // {
  //   icon: <MonitoringIcon />,
  //   id: ManagerPath.Monitoring,
  //   value: 'Мониторинг',
  //   subMenu: [
  //     {
  //       id: MonitoringPath.Dashboard,
  //       value: 'Дашборд',
  //       href: concatPath([RootPath.Manager, ManagerPath.Monitoring, MonitoringPath.Dashboard]),
  //     },
  //     {
  //       id: MonitoringPath.Mentions,
  //       value: 'Упоминания',
  //       href: concatPath([RootPath.Manager, ManagerPath.Monitoring, MonitoringPath.Mentions]),
  //     },
  //     {
  //       id: MonitoringPath.Settings,
  //       value: 'Настройки',
  //       href: concatPath([RootPath.Manager, ManagerPath.Monitoring, MonitoringPath.Settings]),
  //     },
  //   ],
  // },
  {
    icon: <MonitoringIcon />,
    id: ManagerPath.Monitoring,
    service: 'monitoring',
    value: 'Мониторинг',
    permissionsService: 'monitoring',
    subMenu: [
      {
        id: MonitoringScopePath.ReviewSources,
        value: 'Источники отзывов',
        href: concatPath([RootPath.Manager, ManagerPath.Monitoring, MonitoringScopePath.ReviewSources]),
      },
      {
        id: MonitoringScopePath.ExternalReviews,
        value: 'Внешние отзывы',
        href: concatPath([RootPath.Manager, ManagerPath.Monitoring, MonitoringScopePath.ExternalReviews]),
      },
    ],
  },
  {
    icon: <MenusIcon />,
    id: ManagerPath.Menu,
    service: 'menu',
    value: 'Меню',
    permissionsService: 'menu',
    subMenu: [
      {
        id: MenuPath.Informer,
        value: 'Informer',
        href: concatPath([
          RootPath.Manager,
          ManagerPath.Menu,
          MenuPath.Informer,
          InformerPath.List,
        ]),
      },
      {
        id: MenuPath.Iiko,
        value: 'iiko',
        href: concatPath([RootPath.Manager, ManagerPath.Menu, MenuPath.Iiko]),
        service: 'iiko',
      },
    ],
  },
  {
    icon: <LeadsIcon />,
    id: ManagerPath.Lead,
    value: 'Лиды',
    href: concatPath([RootPath.Manager, ManagerPath.Lead, LeadesPath.List]),
    permissionsService: 'lead',
    service: 'lead',
  },
  {
    icon: <PromosIcon />,
    id: ManagerPath.Promotion,
    value: 'Акции',
    href: concatPath([RootPath.Manager, ManagerPath.Promotion, PromotionPath.List]),
    permissionsService: 'promotion',
    service: 'promotion',
  },
  {
    icon: <FormsIcon />,
    id: ManagerPath.Form,
    value: 'Формы',
    href: concatPath([RootPath.Manager, ManagerPath.Form, FormPath.List]),
    permissionsService: 'form',
    service: 'form',
  },
  {
    icon: <DevicesIcon />,
    id: ManagerPath.Devices,
    value: 'Устройства',
    href: concatPath([RootPath.Manager, ManagerPath.Devices, DevicesPath.List]),
    permissionsService: 'device',
  },
];
